'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = require('prop-types');

var _iBemReact = require('@yandex-lego/i-bem-react');

;
exports.default = (0, _iBemReact.decl)({
    tag: 'span',
    block: 'user2',
    elem: 'menu-counter',

    mods: function mods() {
        var count = this.props.count;

        return {
            state: count === 0 && 'empty'
        };
    },
    content: function content() {
        var _props = this.props,
            count = _props.count,
            maxCount = _props.maxCount;

        return count > maxCount ? maxCount : count;
    }
}, {
    propTypes: {
        count: _propTypes.number.isRequired,
        maxCount: _propTypes.number
    },

    defaultProps: {
        maxCount: 9999
    }
});